export const permissoes = {
	Vendedor: 5,
	Operador: 10,
	Financeiro: 11,
	RT: 12,
	Clinica: 13,
	Administrador: 20,
	Farmeos: 99
};
